<template>
  <b-container fluid class="contact">
    <b-row>
      <b-col style="padding: 0px;">
        <div class="text-center backgroundImg" v-bind:style="{background: 'url(' + getImage(bannerImg, 'banner') +')'}" >
          <div class="title-top text-uppercase">Call us @ <b>{{phoneNumber}}</b></div>
          <div class="title-middle text-uppercase primaryColor">{{contactTitleMid}}</div>
          <center>
            <div class="title-bottom">
              {{contactTitleBot}}
            </div>
          </center>
        </div>
      </b-col>
    </b-row>
    <b-row class="text-center">
      <b-col lg="12" md="12" sm="12" xs="12" class="mt-5">
        <h4>Email kami di: <u>sekretariat@dutasaranakonstruksi.com</u></h4>
      </b-col>
    </b-row>
    <!-- Contact -->
    <b-row class="section1 p-5 text-left">
      <b-col lg="6" md="6" sm="12" xs="12" class="mb-5">
        <div class="text-uppercase">
          {{contactDynamicText1}}
        </div>
        <div class="dash">
          <h3>{{contactDynamicText2}}</h3> 
        </div>
        <div class="clearfix"></div>
        <div class="form">
          <div class="fieldWrapper">
            <input type="text" placeholder="Nama Anda" v-model="inquiry.name">
            <div class="prefixIcon"><i class="material-icons">face</i></div>
          </div>
          <div class="fieldWrapper">
            <input type="email" placeholder="Email Anda" v-model="inquiry.email">
            <div class="prefixIcon"><i class="material-icons">email</i></div>
          </div>
          <div class="fieldWrapper">
            <input type="text" placeholder="Nomor Telepon" v-model="inquiry.phoneNumber">
            <div class="prefixIcon"><i class="material-icons">phone</i></div>
          </div>
          <div class="submitEmail p-3 text-center text-uppercase" v-on:click="sendEmail">
            Kirim
          </div>
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12" xs="12" class="mb-3">
        <div class="text-uppercase">
          {{contactDynamicText3}}
        </div>
        <div class="dash">
          <h3>{{contactDynamicText4}}</h3>
        </div>
        <div class="clearfix"></div>
        <GmapMap
          :center="position"
          :zoom="15"
          map-type-id="terrain"
          style="width: 100%; height: 350px"
        >
          <GmapMarker
            :position="position"
            :clickable="false"
            :draggable="false"
          />
        </GmapMap>
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'
import {mapGetters} from 'vuex'

export default {
  name: 'ContactUs',
  data () {
    return {
      bannerImg: 'dsk-contact-bg.jpg',
      p: '021-555-8000',
      a: 'Jl. M.H. Thamrin No. 5A, Kebon Melati, Tanah Abang, Jakarta Pusat',
      cPhoneNumberId: 'cPhoneNumber',
      inquiry: {
        email: '',
        name: '',
        phoneNumber: ''
      },
      errors: [],
      position: {lat: -6.202237, lng: 106.714959}
    }
  },
  methods: {
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    formatPrice (value) {
      return util.currencyFormat(value)
    },
    resetForm () {
      this.$data.inquiry.name = ''
      this.$data.inquiry.email = ''
      this.$data.inquiry.phoneNumber = ''
    },
    validateForm () {
      if (this.$data.inquiry.name === '' || this.$data.inquiry.email === '' || this.$data.inquiry.email === '' || this.$data.inquiry.name.trim() === '' || this.$data.inquiry.email.trim() === '' || this.$data.inquiry.email.trim() === '') {
        this.$data.errors.push('Semua kolom wajib diisi')
        return false
      }
      return true
    },
    sendEmail () {
      if (this.validateForm()) {
        this.$store.dispatch('sendMessage', {
          data: {
            message: this.$data.inquiry
          },
          success: () => {
            this.toast('Terima kasih, Anda akan segera kami hubungi.', 'success', 'check')
            this.resetForm()
          },
          fail: () => {
            this.toast('Maaf, ada gangguan sistem saat ini. Silahkan dicoba sesaat lagi.', 'error', 'error_outline')
          }
        })
        // this.$store.dispatch('createInquiry', {
        //   data: {
        //     inquiry: this.$data.inquiry
        //   },
        //   success: () => {
        //     this.toast('Terima kasih, Anda akan segera kami hubungi.', 'success', 'check')
        //     this.resetForm()
        //   },
        //   fail: () => {
        //     this.toast('Maaf, ada gangguan sistem saat ini. Silahkan dicoba sesaat lagi.', 'error', 'error_outline')
        //   }
        // })
      } else {
        this.toast(this.$data.errors[0], 'error', 'error_outline')
        this.isLoading = false
      }
    },
    findPhoneNumber () {
      this.$data.isLoading = true
      this.$store.dispatch('findContentById', {
        data: {
          id: this.$data.cPhoneNumberId
        },
        success: () => {
        },
        fail: () => {
        }
      }).then(() => {
        this.$data.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    toast (msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      })
    },
    findContentById (id) {
      this.$data.isLoading = true
      this.$store.dispatch('findContentById', {
        data: {
          id: id
        },
        success: () => {
        },
        fail: () => {
          this.toast('Something went wrong. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.$data.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    findAllContents () {
      this.isLoading = true
      this.$store.dispatch('findAllContents', {
        success: (res) => {
        },
        fail: () => {
          this.toast('Could not get contents. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    }
  },
  created () {
    this.findAllContents()
    // this.findContentById('contactTitleMid')
    // this.findContentById('contactTitleBot')
    // this.findContentById('contactDynamicText1')
    // this.findContentById('contactDynamicText2')
    // this.findContentById('contactDynamicText3')
    // this.findContentById('contactDynamicText4')
  },
  computed: {
    ...mapGetters([
      'phoneNumber', 'contactTitleMid', 'contactTitleBot', 'contactDynamicText1', 'contactDynamicText2', 'contactDynamicText3', 'contactDynamicText4'
    ])
  }
}
</script>

<style scoped>
.backgroundImg {
  background:
    linear-gradient(
      rgba(0, 0, 0, 0.75)
    ),
    url(../assets/dsk-contact-bg.jpg) center top no-repeat;
  color: #fff;
}
.title-top {
  padding-top: 8vh;
  font-size: 1.2em;
}
.title-middle {
  padding-top: 50px;
  font-size: 2em;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bolder;
  letter-spacing: 5px;
}
.title-bottom {
  padding: 40px 10px 40px 10px;
  max-width: 950px;
  font-size: 1.2em;
}
.dash:after {
  content: ' ';
  clear: both;
  width: 5em;
  display: block;
  margin: 0 0 1.4em;
  border-bottom: 4px solid #FBBD02;
  float: left;
}
.fieldWrapper {
  background-color: #fff;
  overflow: hidden;
  position: relative;
	display: inline;
}
.fieldWrapper input {
  border: none;
  border-bottom: 1px solid #000;
  padding: 10px 10px 10px 70px;
  width: 100%;
  outline: none;
  line-height: 1.5;
  margin-bottom: 15px;
}
.prefixIcon {
  background-color: #FF8F00;
  position: absolute;
  top: -11px;
  bottom: -11px;
  font-size: 2em;
  padding: 0px 20px;
  color: #fff;
}
.submitEmail {
  width: 100%;
  background-color: #FF8F00;
  color: #FFF;
  -webkit-transition: 300ms ease-in;
  -moz-transition: 300ms ease-in;
  -o-transition: 300ms ease-in;
  transition: 300ms ease-in;
}
.submitEmail:hover {
  cursor: pointer;
  background-color: #FFA000;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactUs.vue